export {};

const preview = new URLSearchParams(window.location.search).get("preview");

if (
  process.env.NODE_ENV === "development" &&
  (preview === "work-types" ||
    preview === "work-type-management" ||
    preview === "form12-document")
) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { mountDebugSurface } = require("./dev/debug-entry");
  mountDebugSurface();
} else {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require("./app-bootstrap");
}
